export default "__VITE_ASSET__C07BW1iK__"